import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { FingerprintProvider } from "@fingerprint/react";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <FingerprintProvider
    apiKey={process.env.REACT_APP_FPJS_PUBLIC_KEY}
    endpoints={[process.env.REACT_APP_FPJS_ENDPOINT]}
    region={process.env.REACT_APP_FPJS_REGION}
  >
    <App />
  </FingerprintProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
